import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Select
import Select from "react-select";

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Yup
import * as yup from 'yup';

// Formik
import { Form, Formik } from 'formik';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import FunctionalTextInput from '../../components/Inputs/FunctionalInput';
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import LoginForm from '../../components/LoginForm';

@inject('AuthStore', 'StoreStore')
@observer

class CreatePaymentNotification extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const systemInitialValues: any = {
            quantity: 0,
            currency: { value: "", label: Helpers.translation('please_choose') },
            description: "",
            account_number: { value: "", label: Helpers.translation('please_choose') },
            payment_date: "",
        };

        const storeId: any = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('create')}
                    visibleCategories={false}
                >
                    <section id="breadcrumbs" className="pt-6 bg-gray-50">
                        <div className="container mx-auto px-4 text-xs md:text-base">
                            <ol className="list-reset flex">
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/home`}
                                    >
                                        {Helpers.translation('home')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/paymentnotifications`}
                                    >
                                        {Helpers.translation('payment_notifications')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>{Helpers.translation('create')}</li>
                            </ol>
                        </div>
                    </section>

                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto mb-8">
                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <Formik
                                                initialValues={systemInitialValues}
                                                onSubmit={(values: any, { resetForm }) => {
                                                    confirmAlert({
                                                        title: Helpers.translation('warning'),
                                                        message: Helpers.translation('create-alert-text'),
                                                        buttons: [
                                                            {
                                                                label: Helpers.translation('yes'),
                                                                onClick: async () => {
                                                                    const response: any = Helpers.createPaymentNotification(values)

                                                                    if (response.status) {
                                                                        resetForm(systemInitialValues);
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                label: Helpers.translation('no'),
                                                            }
                                                        ]
                                                    });
                                                }}
                                                validationSchema={yup.object().shape({
                                                    quantity: yup
                                                        .number()
                                                        .required(Helpers.translation('cannot_be_left_blank')),
                                                    currency: yup.object().shape({
                                                        value: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                    }),
                                                    account_number: yup.object().shape({
                                                        value: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                    }),
                                                    payment_date: yup
                                                        .string()
                                                        .required(Helpers.translation('cannot_be_left_blank')),
                                                })}
                                            >
                                                {(props: any) => {
                                                    return (
                                                        <Form className="w-full mt-4">
                                                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                                <FunctionalTextInput
                                                                    name="quantity"
                                                                    placeholder={Helpers.translation('quantity')}
                                                                    label={Helpers.translation('quantity')}
                                                                    errors={props.errors.quantity}
                                                                    value={props.values.quantity}
                                                                />

                                                                <div>
                                                                    <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('currency')}</label>

                                                                    <Select
                                                                        options={Helpers.getCurrencySelectBoxValues()}
                                                                        value={props.values.currency}
                                                                        onChange={(value) => props.setFieldValue("currency", value)}
                                                                    />

                                                                    {
                                                                        props.errors.currency !== undefined &&
                                                                        <div className="text-red-500 text-sm mt-1">{props.errors.currency.value}</div>
                                                                    }
                                                                </div>

                                                                <div>
                                                                    <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('account_number')}</label>

                                                                    <Select
                                                                        options={Helpers.getAccountNumberSelectBoxValues()}
                                                                        value={props.values.account_number}
                                                                        onChange={(value) => props.setFieldValue("account_number", value)}
                                                                    />

                                                                    {
                                                                        props.errors.account_number !== undefined &&
                                                                        <div className="text-red-500 text-sm mt-1">{props.errors.account_number.value}</div>
                                                                    }
                                                                </div>

                                                                <div>
                                                                    <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('payment_date')}</label>

                                                                    <input
                                                                        type="date"
                                                                        className="border border-gray-300 rounded h-10 w-full px-2"
                                                                        value={props.values.payment_date}
                                                                        onChange={(value: any) => props.setFieldValue('payment_date', value.target.value)}
                                                                    />

                                                                    {
                                                                        props.errors.payment_date !== undefined &&
                                                                        <div className="text-red-500 text-sm mt-1">{props.errors.payment_date}</div>
                                                                    }
                                                                </div>

                                                                <div>
                                                                    <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('receipts')}</label>

                                                                    <input
                                                                        className="border border-gray-300 rounded w-full py-2 px-3 text-grey-darker h-10 text-sm"
                                                                        id="file"
                                                                        name="receipts"
                                                                        type="file"
                                                                        multiple
                                                                        onChange={(event: any) => {
                                                                            props.setFieldValue("receipts", event.currentTarget.files);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="mt-4">
                                                                <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('description')}</label>
                                                                <textarea
                                                                    className="border border-gray-300 rounded h-40 w-full px-2"
                                                                    value={props.values.description}
                                                                    onChange={(value: any) => props.setFieldValue('description', value.target.value)}
                                                                >
                                                                </textarea>
                                                            </div>

                                                            <FunctionalButton
                                                                text={Helpers.translation('create')}
                                                                fullWidth={false}
                                                                customClasses="mt-4"
                                                                rounded
                                                            />
                                                        </Form>
                                                    )
                                                }}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <CreatePaymentNotification {...props} navigate={navigate} />
}

export default WithNavigate